import { useWeb3React } from '@web3-react/core';
import { Contract, ethers, Signer } from 'ethers';
import {
  ChangeEvent,
  MouseEvent,
  ReactElement,
  useEffect,
  useState,
  useRef
} from 'react';
//import { BigNumber } from 'ethers';
import { SignMessage } from './SignMessage';
import styled from 'styled-components';
import { Provider } from '../utils/provider';
import { SectionDivider } from './SectionDivider';
import { Row, Col, Card, Modal, Button} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { OGCounterApp } from './OGCounterApp';


//BUSD LIVE
import BUSD_Artifact from '../live_artifacts/contracts/BUSDToken.sol/BUSDToken.json';
import BUSD_Address from '../live_artifacts/contracts/BUSDToken.sol/BUSDToken-address.json';

//SAFUU LIVE
import SAFUU_Artifact from '../live_artifacts/contracts/SAFUUToken.sol/SAFUUToken.json';
import SAFUU_Address from '../live_artifacts/contracts/SAFUUToken.sol/SAFUUToken-address.json';

//Contract LIVE
import OGNFTArtifact from '../live_artifacts/contracts/OGNFT.sol/OGNFT.json';
import OGNFTAddress from '../live_artifacts/contracts/OGNFT.sol/OGNFT-address.json';

const StyledGreetingDiv = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 135px 2.7fr 1fr;
  grid-gap: 10px;
  place-self: center;
  align-items: center;
`;

const StyledLabel = styled.label`
  font-weight: bold;
`;

const StyledInput = styled.input`
  padding: 0.4rem 0.6rem;
  line-height: 2fr;
`;

const StyledButton = styled.button`
  width: 150px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledAppDiv = styled.div`
  display: grid;
  grid-gap: 20px;
`;


export function OGHoldingPageApp(): ReactElement {
  return (
    <StyledAppDiv>
      <CreateOGPage />
    </StyledAppDiv>
  );
}

export function CreateOGPage(): ReactElement {

  const context = useWeb3React<Provider>();
  const { library, active, account } = context;

  const [signer, setSigner] = useState<Signer>();
  const [NFTContract, setNFTContract] = useState<Contract>();
  const [NFTContractAddr, setNFTContractAddr] = useState<string>('');

  const [image, setImage] = useState('');
  const [price, setPrice] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const reffirstRef = useRef(null);

  const [nftTokenName, setTokenName] = useState<string>('');
  const [nftTokenSymbol, setTokenSymbol] = useState<string>('');
  const [nftTokenOwner, setTokenOwner] = useState<string>('');
  const [approveAmountInput, setApproveAmountInput] = useState<string>('');
  const [buyCFALPHAButton, setBuyCFALPHAButton] = useState<string>('APPROVE BUSD & MINT OG NFT');
  const [buyCFALPHASafuuButton, setBuyCFALPHASafuuButton] = useState<string>('APPROVE SAFUU & MINT OG NFT');

  const [totalBUSDRaised, setTotalBUSDRaised] = useState(0);
  const [totalSAFUURaised, setTotalSAFUURaised] = useState(0);
  const [busdBalance, setbusdBalance] = useState(0);
  const [safuuBalance, setsafuuBalance] = useState(0);
  const [totalNFTSupply, setTotalNFTSupply] = useState(0);
  const [items, setItems] = useState<any[]>([]);

  const [transferBUSDAmountInput, setTransferBUSDAmountInput] = useState<string>('');
  const [transferSAFUUAmountInput, setTransferSAFUUAmountInput] = useState<string>('');

  const [loading, setLoading] = useState(true);

  useEffect((): void => {
    if (!library) {
      setSigner(undefined);
      return;
    }

    setSigner(library.getSigner());
  }, [library]);

  //Because state update is asynchronous we must listen for signer to be updated
  useEffect(() => {
    handleAttachContract();
    createOGArray();
  }, [signer]);

  //test for account change
  useEffect(() => {
    setLoading(true);
    handleAttachContract();
    createOGArray();
  }, [account]);

  function createOGArray() {

    if (!signer) {
      return;
    } 

    async function attachNFTCreatArray(signer: Signer): Promise<void> {

    const NFT = new ethers.ContractFactory(
      OGNFTArtifact.abi,
      OGNFTArtifact.bytecode,
      signer
    );

    const nftContract = await NFT.attach(OGNFTAddress.address);
       
        setNFTContract(nftContract);
 
       // window.alert(`P2EGame deployed to: ${p2eGameContract.address}`);
    
        //Get MINT details for 99 NFTs
        let imageurls = [];

        imageurls.push('PASS ZERO ADDRESS');
        imageurls.push('https://ipfs.io/ipfs/QmYGAm7SBbPuUTs2FhLyvVBbbyN3FKo9ftT1fexqR5Ps12');
        imageurls.push('https://ipfs.io/ipfs/QmVGc8beFzXxNRunGUQkLeQtAYAXZeUB6UQEu9JHUMPGfh');
        imageurls.push('https://ipfs.io/ipfs/QmR2QxrsvBGCMYnsSWLjDLKR3PEoqmcxv1FaWdz5Qt8Z8J');
        imageurls.push('https://ipfs.io/ipfs/QmXVg9jNnHvG6jnwQ79LuRJZ4BrGikRAhidF6Fan7RCMTE');
        imageurls.push('https://ipfs.io/ipfs/QmVVjMotjEJ37mzsGVvV1x6Q1ww27d9EGrnbWfTbjSoENZ');
        imageurls.push('https://ipfs.io/ipfs/Qma5y5MKxPyhzN2EeQtCCKFoQ1NHpoQ72vEHWKWRsBZswb');
        imageurls.push('https://ipfs.io/ipfs/QmcXww64AGh6FXQX7s47ZLjYqFa9rcGro9hCVZsAtWe68y');
        imageurls.push('https://ipfs.io/ipfs/QmXAdj64rMtSirrVLgidd5ZJfwHCStiJCUEgyYMsZ1uptX');
        imageurls.push('https://ipfs.io/ipfs/QmcsYfe6RDoqDw5hoE8Mch1ZEavkmBAsX8hGcd56YHMUF5');
        imageurls.push('https://ipfs.io/ipfs/QmbHXyHbCEw4SPVHPEpPayhn8BT8GrafnRdkdGPLTnqryh');
        imageurls.push('https://ipfs.io/ipfs/QmZaA9vZ9tZDCqr2vv9pXkgqoMCxnLGxDKu5DUCh3t8re9');
        imageurls.push('https://ipfs.io/ipfs/QmTfeThAu4SH1sLkVVgiqh7Sp2DxanXapP3yZG4wyYK3od');
        imageurls.push('https://ipfs.io/ipfs/QmRAQqronV3qYiUSbFKpePhbz2hcW4AQiQFu9TkrTmrb3m');
        imageurls.push('https://ipfs.io/ipfs/Qmak9oWD7so6an6Xe54cHg2XS9evDzYAZcHoZ7fXPguMkg');
        imageurls.push('https://ipfs.io/ipfs/QmWEuWe65kDjHwVXR6PoP1Qsyq2B8rmPT5aCqNKGU3mXLi');
        imageurls.push('https://ipfs.io/ipfs/QmPztjPUNQWbM3WV419kDLSs4h8FmLkbrnF72cmSu7KSWV');
        imageurls.push('https://ipfs.io/ipfs/QmfLffSZpVvduyhH2xqicHyDPa9XV6hcKVRSKn7A5h1Emv');
        imageurls.push('https://ipfs.io/ipfs/QmUMsL7VbwZopMdzH459sD7H6kk7pya5bTHXkipDiB5urJ');
        imageurls.push('https://ipfs.io/ipfs/QmUr5FmF1UWyvZsjjNXEDqxMMR9QZyAJWnL5muXsz9rVNd');
        imageurls.push('https://ipfs.io/ipfs/QmaJFQk7bUYz89YjUvXRXeeTvaxMSrH8S99iY9bxaXzYFz');
        imageurls.push('https://ipfs.io/ipfs/QmTMdvKrbPsYLogiXwukg5cFobcfkyE9gStkVxA7xzx3G7');
        imageurls.push('https://ipfs.io/ipfs/QmTiZmetncA81RWSt6T1nQ9J3ybLf78nD9kQ4ZbwpyGNHb');
        imageurls.push('https://ipfs.io/ipfs/QmaxwrZrZ3eFrU2qrXkDfJomkFMnopLcxthkLRK7BEPbWU');
        imageurls.push('https://ipfs.io/ipfs/QmULPSz7zRuhgBsBdDGwassFcsz1a12r1iEhg4Srecu2yN');
        imageurls.push('https://ipfs.io/ipfs/QmWz34DFnSGuDfzJKJn6ot2MMssw9dNDb9xNL6JESoQzWZ');
        imageurls.push('https://ipfs.io/ipfs/QmS2FiqxsAsLcgCPW2sppQ8kxtHYR2cuwnxcHuoSSfqbbS');
        imageurls.push('https://ipfs.io/ipfs/QmPMihWhJDHxvCyxGFyti1wVFrMCjAVfAo54MzfaTrNUTW');
        imageurls.push('https://ipfs.io/ipfs/QmaS7iUxkDH8PtsitpQRkHHJm5V6uFmGqhWrAxBSbW676y');
        imageurls.push('https://ipfs.io/ipfs/QmSxopWDACoiyR2zTmobuBovJpXLpMyuMX9t9U4ZHFd1mQ');
        imageurls.push('https://ipfs.io/ipfs/QmYoCzGJHbV68Mhj8jxcR4Pp9tLU32quxhPtNpuEmBAEnY');
        imageurls.push('https://ipfs.io/ipfs/QmPiza4iiGhLacqeFCV62vDeXMtfZufPMWCMabQg2mp7N6');
        imageurls.push('https://ipfs.io/ipfs/QmZStCdSYFvZ1LpXNG85K1csgSwaQZNoZpH7GF5NZz6uGi');
        imageurls.push('https://ipfs.io/ipfs/QmeWhiYyvzbrkQfSfrnJgdpEKiMQYDWjMpJvP61kHWvioz');
        imageurls.push('https://ipfs.io/ipfs/QmacDtxATYKdtCu5hbfqpUDCptB1CypvRPJqmVC2tZFkVu');
        imageurls.push('https://ipfs.io/ipfs/QmPG5oVZAXZLGFtcxbs4WVYosni7kY2gdkZ5LjLx897UtG');
        imageurls.push('https://ipfs.io/ipfs/QmUVzu2BpGVyigzwBa5nbPBEf4bTiZQrdbKNXzYvFhmJtP');
        imageurls.push('https://ipfs.io/ipfs/QmUEXXi3KhXJGb2kLkighokQgyLjBqxn82HcAmXDxfPQ7a');
        imageurls.push('https://ipfs.io/ipfs/QmQMfA5aynzBdWhncr9D29zfvNZkEwfbATnVkMzqdcisv1');
        imageurls.push('https://ipfs.io/ipfs/QmeYBhyJHBraB6kXyvAAWPaDLDG1tqx13YjF2mTfmPzGJo');
        imageurls.push('https://ipfs.io/ipfs/QmdA2LrM2xp3AvCsU4XFdpYdmiySFEhnLKXB7u1KUeb2QG');
        imageurls.push('https://ipfs.io/ipfs/QmZzhrUVLMcSvUGDpyPuPktNwNFR1p7UyQycoX1sqZrJ1x');
        imageurls.push('https://ipfs.io/ipfs/QmRRV1xz4pVCBYuVMSRwWA7vVaeNFDoLY9MrLhGqZS2tsm');
        imageurls.push('https://ipfs.io/ipfs/QmPGtj1Z6AgTmT6xqRCyHLzhqRBjaWJHuEvzvwnfiqz6hL');
        imageurls.push('https://ipfs.io/ipfs/QmNg3dBV1skvgBKexkUNZ3yuow6Wfk57G8mxHAvY8eX35f');
        imageurls.push('https://ipfs.io/ipfs/QmW1z85ntKWdNEwjn7g7FjzgAqYhceHEgTHLAeWBA2t3NS');
        imageurls.push('https://ipfs.io/ipfs/QmQ7zQWUDNJAMT185gjLi8vDj6sYGGsPxLEcvD3ESv7Fb3');
        imageurls.push('https://ipfs.io/ipfs/QmTPbipa2JMwrsQKxxuY7oe5zSEm3ppkEyDD9vppecWUuk');
        imageurls.push('https://ipfs.io/ipfs/QmYzW9UoUHLKDBpZPCB1Vpp8ev16wRQpzYAnCrVgtiHQvj');
        imageurls.push('https://ipfs.io/ipfs/QmPku8AiVC9Y2x8Kf8cRFfd1By6tGEGGwC6tneSZnDEQ1n');
        imageurls.push('https://ipfs.io/ipfs/QmfAYUpzQ3MLLcrDepLymUDxaYLeGnjDCvtvYtJpSix6mt');
        imageurls.push('https://ipfs.io/ipfs/QmbWjwik5UR8YxLS9Nn5ynXKcQRc7WTR7dVuDx6MxpcMu5');
        imageurls.push('https://ipfs.io/ipfs/QmcYGAW94AHwxepmew3Qt6WciJ2wNbhEnFAASRNzMNiQkF');
        imageurls.push('https://ipfs.io/ipfs/QmYxzFgeL5T3AohjrQLYtV5FZsbZMXc8yCG6MmFddpwTK2');
        imageurls.push('https://ipfs.io/ipfs/QmZdqq1Ddd5HihtpK5z6ncybdsw71FdU2dcXpDNiJRP4u5');
        imageurls.push('https://ipfs.io/ipfs/QmajeEYkgNn6vfB6xGiK3E5f3LCfEnxcKKG2VxFJZHZvQh');
        imageurls.push('https://ipfs.io/ipfs/QmYzy2xuRsmvUbXwAkpZFRH3ufiwvMxqd6BMPt3wjWPdT9');
        imageurls.push('https://ipfs.io/ipfs/QmTtM4htaH1iHHgBsx54ZmV3mw5FhPmRTt1hdtWzi5ZNFa');
        imageurls.push('https://ipfs.io/ipfs/QmWCZyPNpxbDbUSJXkRgpsFdYzmQoCVBgn4Mu4fCZbsN7i');
        imageurls.push('https://ipfs.io/ipfs/QmbGZXVZc4CZu91KXwfJ9RfUMnEst2mHwQqFCZEASscSrN');
        imageurls.push('https://ipfs.io/ipfs/QmcUJj9AjdkLcKGtvtwSTQeLp4RPcm8XCctUVQ1czQJgmW');
        imageurls.push('https://ipfs.io/ipfs/QmPG4jpoumEUMuTmg7srUkmojRER2D5FUmUxcjD1mXP35B');
        imageurls.push('https://ipfs.io/ipfs/QmRWKYiPgPvoV3iiMKKdxjdRXHAjAqUojRH36BRoUEXohY');
        imageurls.push('https://ipfs.io/ipfs/QmYL3kHrKpkUJSL3BhUuBPNWZQGF93iEpjC84kerCxWtQE');
        imageurls.push('https://ipfs.io/ipfs/QmULf8qXKQGHNJa247b3fGzKsWw3r4f7FZTZ3nvmUCEtqQ');
        imageurls.push('https://ipfs.io/ipfs/QmcPVVkPdkyijQrRSppynjKWvwyQZSYxH9kjrmbWxmMcQ1');
        imageurls.push('https://ipfs.io/ipfs/QmcKGdyjLn7vYENSe468521j2DVn1r7x1Jsa8T9HmPmd91');
        imageurls.push('https://ipfs.io/ipfs/QmbFTabUUeWDaDUncaw54WV8q17FY8f9n8G2hTZRHgJRUC');
        imageurls.push('https://ipfs.io/ipfs/QmQ1yqHtcqijQtcnLJsQHMaCWyLRqjnoyTcEVMeRUqveC3');
        imageurls.push('https://ipfs.io/ipfs/QmYhrVoVnHQ5ZCEqX8DXpmUGLpV9ogGn4hZKsbPcC2M1Fw');
        imageurls.push('https://ipfs.io/ipfs/QmboczkiSzZXaZGBmFHpabQm4LYjhQd8LoWzXpf7tNuxFB');
        imageurls.push('https://ipfs.io/ipfs/QmVJ4scE3rvkgPxHKKHPfgqAT1wub1WU3oNqEvoibbnTDU');
        imageurls.push('https://ipfs.io/ipfs/QmdidCNJp75NsYFP6iAEJunQ2u8dvCcTt4icht8RzUFcnD');
        imageurls.push('https://ipfs.io/ipfs/QmdEfvxdiGyWxkGSWxabxL5YMUTxGfVBi8cmaiKPFQnvRb');
        imageurls.push('https://ipfs.io/ipfs/QmSgL7aQBe4G524s2fhdQtrJbeTDeHaixrasSXAEtDgJCU');
        imageurls.push('https://ipfs.io/ipfs/QmbQFBJqQR6oZBay7b9Paa6Yrv5z2hFpLaapc24exBoU6m');
        imageurls.push('https://ipfs.io/ipfs/QmZyXd7wCdEexgVRHXbJ5Ev91HWWVFeVS2APeddFUYTvTq');
        imageurls.push('https://ipfs.io/ipfs/Qmdbpyu5RyninvM3gFBpYa82iybkrTCRkeQirBATfTSQ71');
        imageurls.push('https://ipfs.io/ipfs/QmY7YeqGBydTag8bmJQ4CwgaF1dRhjFcpz82RNT3wuhh8p');
        imageurls.push('https://ipfs.io/ipfs/QmbqLFyWtCH6jvRsnJrFVsPxHSXTL4vdzQ7LKVYbRzTLsH');
        imageurls.push('https://ipfs.io/ipfs/QmRmobTuSRZ4ToFFHeUXhHCmpGrBZ5W4ZqcBKWMsSrutxK');
        imageurls.push('https://ipfs.io/ipfs/QmXvYcNzgkkWAg3KvbmQxHxcz7EPvMk4awrWuZ5JLa2S3T');
        imageurls.push('https://ipfs.io/ipfs/QmNPQviPZx3kxDrQJnd9gE5wxmc1SHGoA1Fg4gWBgXVUoM');
        imageurls.push('https://ipfs.io/ipfs/QmWZ7Bz6PTV8aiDbEYRLTBhZpiNzJEoh18NmM1G7UpxPB2');
        imageurls.push('https://ipfs.io/ipfs/QmQD9PL4GUxLGvHf9jb3rykvWHyzb2dbTSL2jNcesUPCUS');
        imageurls.push('https://ipfs.io/ipfs/QmeU3EXbZrHrhEXyPdmL9AC3fLG7mZt8fsGdQXkvwQWkbK');
        imageurls.push('https://ipfs.io/ipfs/QmYRhYoXkQkU3DNfd1HtxL956ge5VsWN2YJP1vUEdzveZh');
        imageurls.push('https://ipfs.io/ipfs/QmWAisPJbQjwdG8HqaSCYGwTWLCpz2pL1bZKdvDQDgymsb');
        imageurls.push('https://ipfs.io/ipfs/Qmb15QCaD7vtTHmEyYiNQ8fZeC4XCDmQuRo9Qhx7wZCdAt');
        imageurls.push('https://ipfs.io/ipfs/QmYfVyH4Z4RuwQGPQb5TPviSbBCUQ7bz2PNis7hB7GXgzZ');
        imageurls.push('https://ipfs.io/ipfs/QmXek9rXCgD2kDFpRfcmWE4mJnDcxZKVzQRUmniNMW41yJ');
        imageurls.push('https://ipfs.io/ipfs/QmNqGfdS2zZ64nEpRJVFuiQAChDAeYcB4fdL7N9mPGR9id');
        imageurls.push('https://ipfs.io/ipfs/QmV8JFJ7q7kTrGSkNbUGPVAdQtyEg99gk4j7aPzB3z4T1e');
        imageurls.push('https://ipfs.io/ipfs/Qmd7t4DKLZHkFhaBzAmyrDXCJvAMWWA1dgmDhJqsBVncPX');
        imageurls.push('https://ipfs.io/ipfs/QmcJUQssmtPWsMyst6fXQDygeaVpDD4rTEULo5BPuxz4Uq');
        imageurls.push('https://ipfs.io/ipfs/QmaoACdW52UUjmSBgNZZAprSnM6eCDbrKweHPeEadQzPDe');
        imageurls.push('https://ipfs.io/ipfs/QmQhvTyFZKKmDKocNTpYpgBMcN25BHrN6W2TU4iNF8EcNP');
        imageurls.push('https://ipfs.io/ipfs/QmSXeBoDPrvDUiXQ1U6bxNsqDwjdoojRBAiqz3FmMCzA4m');
        imageurls.push('https://ipfs.io/ipfs/QmVcaWDYZGwJ3zVyvqG3FBPKNDQ2Wqxz97GUUoPZF5xPxK');
        imageurls.push('https://ipfs.io/ipfs/QmUCEWnKMrLYy4XY3A3N6iEk9Xi5McWX3UqZ37wi1jX9ik');


       // window.alert(`#1: ${imageurls[1]}`);

       // window.alert(`#99: ${imageurls[99]}`);



       let soldList = [];

       const tokenTotalSupply = await nftContract.totalSupply();
       let soldTokenId;

       try {
        for(let id = 0; id < tokenTotalSupply; id++){

          soldTokenId = await nftContract.tokenByIndex(id);
          soldList.push(soldTokenId);
         }

        } catch {
         
        }

        let listItems = [];
       
        let price;
        let image;
        let soldtext;
        let soldbool;
        const name = 'OG';
        const description = 'COSMIC FORCE OG';
        const ticker = 'CFOG';

        

        for(let id =0; id < 100; id++){

        const itemId = id;

        price = 5000;
        
        //Setup Price array
        if (id == 1) price = 5000;
        if (id == 2) price = 4500;
        if (id == 3) price = 4000;
        if (id == 4) price = 3500;
        if (id == 5) price = 3000;
        if (id == 6) price = 2500;
        if (id == 7) price = 2000;
        if (id == 8) price = 1500;
        if (id == 9) price = 1000;
        if (id >= 10 && id <= 19) price = 500;
        if (id >= 20 && id <= 29) price = 475;
        if (id >= 30 && id <= 39) price = 450;
        if (id >= 40 && id <= 49) price = 425;
        if (id >= 50 && id <= 59) price = 400;
        if (id >= 60 && id <= 69) price = 375;
        if (id >= 70 && id <= 79) price = 350;
        if (id >= 80 && id <= 89) price = 325;
        if (id >= 90 && id <= 99) price = 300;

        image = imageurls[id];

        //CHAGE HERE TO SET SAFUU PRICE
        const safuuprice = price * 6;

        const soldId = soldList.find((soldList)=> soldList == id );

        if (soldId == undefined){

          soldtext = price.toString()+' BUSD';
          soldbool = false;

        } else {

          soldtext = '🔴 SOLD';
          soldbool = true;

        }
          
        let item = {
          itemId: itemId.toString(),
          price: price.toString(),
          safuuprice: safuuprice.toString(),
          name: name,
          description: description,
          ticker: ticker,
          image: image,
          soldtext: soldtext,
          soldbool: soldbool
        }
        listItems.push(item);
 
        }

        setItems(listItems);
        setLoading(false);

      }

      attachNFTCreatArray(signer);

  }

  function handleAttachContract() {
    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function attachNFTContract(signer: Signer): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        OGNFTArtifact.abi,
        OGNFTArtifact.bytecode,
        signer
      );

      try {
        //NOTE: ALWAYS PRE-DEPLOYED
        //const p2eGameContract = await P2EGame.deploy('Cosmic Force','CFX');
        //await p2eGameContract.deployed();

        const nftContract = await NFT.attach(OGNFTAddress.address);
       
        setNFTContract(nftContract);
 
       // window.alert(`P2EGame deployed to: ${p2eGameContract.address}`);

        const tokenName = await nftContract.name();
        const tokenSymbol = await nftContract.symbol();
        const tokenOwner = await nftContract.owner();
        const totalSupply = await nftContract.totalSupply();

        setNFTContractAddr(nftContract.address);
        setTokenName(tokenName);
        setTokenSymbol(tokenSymbol);
        setTokenOwner(tokenOwner);
        setTotalNFTSupply(Number(totalSupply));

        //window.alert(`TokenName: ${tokenName}`);
        //window.alert(`TokenSymbol: ${tokenSymbol}`);

        //Chech if BUSD approved and change to MINT buttin if so
        handleCheckApproveBUSD();
        handleCheckApproveSAFUU();

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    attachNFTContract(signer);
  }

  function handleCreateBUSDNFT(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }


    async function createNFT(signer: Signer, newtokenId: string): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        OGNFTArtifact.abi,
        OGNFTArtifact.bytecode,
        signer
      );

      const BUSD = new ethers.ContractFactory(
        BUSD_Artifact.abi,
        BUSD_Artifact.bytecode,
        signer
      );

      try {

        if (Number(items[Number(newtokenId)].soldbool) == 1) {
          window.alert(`OG NFT #${newtokenId} SOLD TIME TO PICK A DIFFERENT ONE`);
          return;
        }

        const price=items[Number(newtokenId)].price;
        const uri = items[Number(newtokenId)].image;

        window.alert(`Purchasing OG NFT #${newtokenId} for ${price} BUSD`);

        const BUSD_Contract = await BUSD.attach(BUSD_Address.address);

        const amountApproved = await BUSD_Contract.allowance(account, OGNFTAddress.address);
        const balanceBUSD = await BUSD_Contract.balanceOf(account);


        

        //If not enough allowence left
        if (Number(amountApproved) < (Number(ethers.utils.parseEther(price))) ) {
          //Do Approve BUSD

        const listingPrice = ethers.utils.parseEther("30000");

        const setTxn = await BUSD_Contract.approve(OGNFTAddress.address,listingPrice); // = FFFFetc

        await setTxn.wait();

        setBuyCFALPHAButton('MINT OG NFT WITH BUSD');

        window.alert(`BUSD Approve Success!`);

        }

        if(Number(balanceBUSD) < Number(ethers.utils.parseEther(price))) {
          window.alert('Not enough BUSD balance');
          return;
        }

        const nftContract = await NFT.attach(OGNFTAddress.address);
        
        const ticker = "BUSD";
        const tickerId = 0;

        // mint nft 
        const result2 = await(await nftContract.mint(uri,tickerId,newtokenId)).wait();
        // get tokenId of new nft 
        //const id = await nftContract.tokenCount();

        const totalSupply = await nftContract.totalSupply();
        setTotalNFTSupply(Number(totalSupply));


        setBuyCFALPHAButton('MINT OG NFT WITH BUSD');
        handleCheckApproveBUSD();

        window.alert(`Created OG #${newtokenId} NFT`);


      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    createNFT(signer,event.currentTarget.id);
  }

  function handleCreateSAFUUNFT(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function createNFT(signer: Signer, newtokenId: string): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        OGNFTArtifact.abi,
        OGNFTArtifact.bytecode,
        signer
      );

      const SAFUU = new ethers.ContractFactory(
        SAFUU_Artifact.abi,
        SAFUU_Artifact.bytecode,
        signer
      );

      try {

        if (Number(items[Number(newtokenId)].soldbool) == 1) {
          window.alert(`OG NFT #${newtokenId} SOLD TIME TO PICK A DIFFERENT ONE`);
          return;
        }

        const uri = items[Number(newtokenId)].image;
        const price = items[Number(newtokenId)].safuuprice;

        window.alert(`Purchasing OG NFT #${newtokenId} for ${price} SAFUU`);

        const SAFUU_Contract = await SAFUU.attach(SAFUU_Address.address);

        const amountApproved = await SAFUU_Contract.allowance(account, OGNFTAddress.address);
        const balanceSAFUU = await SAFUU_Contract.balanceOf(account);

        //add 5 zeros
        const safuuprice = price * 100000;
        //If not enough allowence left 100000000 = 1000 Safuu
        if (Number(amountApproved) < (Number(safuuprice)) ) {
          //Do Approve SAFUU

        const listingPrice =  "3000000000";

        const setTxn = await SAFUU_Contract.approve(OGNFTAddress.address,listingPrice);

        await setTxn.wait();

        setBuyCFALPHASafuuButton('MINT OG NFT WITH SAFUU');

        window.alert(`SAFUU Approve Success!`);
        }

        //************* Safuu Price extra 5 0s
        if(Number(balanceSAFUU) < Number(safuuprice)) {
          window.alert('Not enough SAFUU balance');
          return;
        }

        const nftContract = await NFT.attach(OGNFTAddress.address);
       
        const ticker = "SAFUU";
        const tickerId = 1;
    
        // mint nft 
        await(await nftContract.mint(uri,tickerId,newtokenId)).wait();
        // get tokenId of new nft 
        //const id = await nftContract.tokenCount();

        const totalSupply = await nftContract.totalSupply();
        setTotalNFTSupply(Number(totalSupply));

        setBuyCFALPHASafuuButton('MINT OG NFT WITH SAFUU');
        handleCheckApproveSAFUU();

        window.alert(`Created OG #${newtokenId} NFT`);

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    createNFT(signer,event.currentTarget.id);
  }

  function handleCheckApproveBUSD(): void {
   
    // only attach when a signer is defined
    if (!signer) {
      return;
    }

  async function approveCheckBUSD(signer: Signer): Promise<void> {
      
      //   const BUSDLIVE = new ethers.ContractFactory(
      //     BUSD_LIVEArtifact.abi,
      //     BUSD_LIVEArtifact.bytecode,
      //     signer
      //   );
  
        const BUSD = new ethers.ContractFactory(
          BUSD_Artifact.abi,
          BUSD_Artifact.bytecode,
          signer
        );
  
        try {
  
          const BUSD_Contract = await BUSD.attach(BUSD_Address.address);
            
          const amountApproved = await BUSD_Contract.allowance(account,OGNFTAddress.address);
  
          const contractBalanceBUSD = await BUSD_Contract.balanceOf(OGNFTAddress.address);     
          const totalRaised = Number(ethers.utils.formatUnits(contractBalanceBUSD,18));
          setTotalBUSDRaised(Math.ceil(totalRaised));
          
    
          const walletNewBalanceBUSD = await BUSD_Contract.balanceOf(account);
          const newBalanceBUSD = Number(ethers.utils.formatUnits(walletNewBalanceBUSD,18));
          setbusdBalance(newBalanceBUSD);
  
          //If not enough allowence left
          if (Number(amountApproved) > 0) {
            setBuyCFALPHAButton('MINT OG NFT WITH BUSD');
          } else {
            setBuyCFALPHAButton('APPROVE BUSD & MINT OG NFT');
          }
          
        } catch (error: any) {
          window.alert(
            'Error!' + (error && error.message ? `\n\n${error.message}` : '')
          );
        }
      }
  
    approveCheckBUSD(signer);
  }

  function handleCheckApproveSAFUU(): void {
   
      // only attach when a signer is defined
      if (!signer) {
        return;
      }
  
      async function approveCheckSAFUU(signer: Signer): Promise<void> {
        
        //   const BUSDLIVE = new ethers.ContractFactory(
        //     BUSD_LIVEArtifact.abi,
        //     BUSD_LIVEArtifact.bytecode,
        //     signer
        //   );
    
          const SAFUU = new ethers.ContractFactory(
            SAFUU_Artifact.abi,
            SAFUU_Artifact.bytecode,
            signer
          );
    
          try {
    
            const SAFUU_Contract = await SAFUU.attach(SAFUU_Address.address);
              
            const amountApproved = await SAFUU_Contract.allowance(account,OGNFTAddress.address);
    
            const contractBalanceSAFUU = await SAFUU_Contract.balanceOf(OGNFTAddress.address);     
            const totalSafuuRaised = Number(ethers.utils.formatUnits(contractBalanceSAFUU,4));
            setTotalSAFUURaised(Math.ceil(totalSafuuRaised));
            
      
            const walletNewBalanceSAFUU = await SAFUU_Contract.balanceOf(account);
            const newBalanceSAFUU = Number(ethers.utils.formatUnits(walletNewBalanceSAFUU,4));
            setsafuuBalance(newBalanceSAFUU);
    
            //If not enough allowence left
            if (Number(amountApproved) > 0) {
              setBuyCFALPHASafuuButton('MINT OG NFT WITH SAFUU');
            } else {
              setBuyCFALPHASafuuButton('APPROVE SAFUU & MINT OG NFT');
            }
            
          } catch (error: any) {
            window.alert(
              'Error!' + (error && error.message ? `\n\n${error.message}` : '')
            );
          }
      }
    
    approveCheckSAFUU(signer);
  }

  const OGs = [];

  for(let i =1; i < 99; i=i+3){
    OGs.push((i));
  }

  if (loading) return (
    <>
    <div className="container-fluid mt-5">
    <div className="row">
      <main role="main" className="col-lg-12 mx-auto" style={{ maxWidth: '1000px' }}>
        <div className="content mx-auto">
        <Row className="g-6">
          <Col className=" text-center ">
          <img src='./images/Title_OG.png' className='img-fluid' alt='...' />
          </Col>
        </Row>
          <div>&nbsp;</div>
        <Row className="g-4">
          <h6 className="p-4 text-center">
          Contract: {NFTContractAddr}
        </h6>
        </Row>
        <Row className="g-4">
          <Col>
          </Col>
          <Col>
          <h4 className="text-center">
            Minted
          </h4>
          </Col>
          <Col>
          <h4 className="text-center">
            Max Supply
          </h4>
          </Col>
          <Col>
          </Col>
        </Row>
        <Row className="g-4">
          <Col>
          </Col>
          <Col>
          <h5 className="text-center">
          {totalNFTSupply}
          </h5>
          </Col>
          <Col>
          <h5 className="text-center">
            99
          </h5>
          </Col>
          <Col>
          </Col>
        </Row>
          <Row className="g-6">
          <Col className=" text-center ">
          <img src='./images/OG1_medium.png' className='img-fluid' alt='...' />
          </Col>
          </Row>
          <Row className="g-4">
          <Col>
          <h5 className="text-center">
          PRICE $300 - $5,000 IN $BUSD
          </h5>
          </Col>
          </Row>
          <div>&nbsp;</div>
          <Row className="g-4">
          <h6 className="p-4 text-center">
          Owning one of the 99 OG NFTs grants you full access to Leaderboards and Rewards from the Cosmic Force Treasury allowing you to progress in the game. The OG NFT also represents additional digital assets including: Starfighter, Custom Starfighter Skin with Personal Decal Graphics, Customizable Avatar, Combat Suit, Planetary Kit, Outpost Pod all issued as individual extra NFTs plus 35% discount of ALL in-game digital NFT asset purchases FOREVER once we launch on the Cosmic Blockchain.
          </h6>
          </Row>
          <div>&nbsp;</div>
          <Row className="g-6">
          <Col className=" text-center ">
          <img src='./images/OG_Suit_UC.png' className='img-fluid' alt='...' />
          </Col>
          </Row>
          <Row className="g-6">
          <Col className=" text-center ">
          <img src='./images/OG_Text_v2.png' className='img-fluid' alt='...' />
          </Col>
          </Row >
          <Row className="g-6">
          <img src='./images/Spaceship.png' className='img-fluid' alt='...' />
          </Row>
          <div>&nbsp;</div>
          <Row className="g-6">
          <img src='./images/Outpost_Pod_no_Border_2.png' className='img-fluid' alt='...' />
          </Row>
          <div>&nbsp;</div>
          <div>&nbsp;</div>
          <Row className="g-6">
          <img src='./images/Planetary_Kit_No_border.png' className='img-fluid' alt='...' />
          </Row>
          <div>&nbsp;</div>
          {OGs.map(name => (
            <div>
             <Row className="g-6">
              <Col className=" text-center ">
                <Card style={{ background: "#000000", border: "2px solid #41464b" }}>
                  <Card.Body  style={{ minWidth: '300px' }}>
                    <Card.Img variant="top" src={`./images/99_OGs_SM/OG(${name})sm.png`} />
                      
                    </Card.Body>
                  <Card.Footer style={{ background: "#212529", borderTop: "2px solid #41464b" }}>
                  <Card.Text>
                          <h4>#{name} {'OG'}</h4>
                      <Row className="g-4">
                      <Col>
                        <div className="d-grid px-8">
                          <Button id={`${name}`} onClick={handleCreateBUSDNFT} variant="primary" size="lg">
                            {buyCFALPHAButton}
                          </Button>
                        </div>
                        </Col>
                      </Row>
                  </Card.Text>
                  </Card.Footer>
                </Card>
              </Col>
              <Col className=" text-center ">
                <Card style={{ background: "#000000", border: "2px solid #41464b" }}>
                  <Card.Body style={{ minWidth: '300px' }}>
                    <Card.Img variant="top" src={`./images/99_OGs_SM/OG(${name+1})sm.png`} />
                      
                    </Card.Body>
                  <Card.Footer style={{ background: "#212529", borderTop: "2px solid #41464b" }}>
                  <Card.Text>
                          <h4>#{name+1} {'OG'}</h4>
                      <Row className="g-4">
                      <Col>
                        <div className="d-grid px-8">
                          <Button id={`${name+1}`}  onClick={handleCreateBUSDNFT} variant="primary" size="lg">
                            {buyCFALPHAButton}
                          </Button>
                        </div>
                        </Col>
                      </Row>
                  </Card.Text>
                  </Card.Footer>
                </Card>
              </Col>
              <Col className=" text-center ">
                <Card style={{ background: "#000000", border: "2px solid #41464b" }}>
                  <Card.Body style={{ minWidth: '300px' }}>
                    <Card.Img variant="top" src={`./images/99_OGs_SM/OG(${name+2})sm.png`} />
                      
                    </Card.Body>
                  <Card.Footer style={{ background: "#212529", borderTop: "2px solid #41464b" }}>
                  <Card.Text>
                          <h4>#{name+2} {'OG'}</h4>
                      <Row className="g-4">
                      <Col>
                        <div className="d-grid px-8">
                          <Button id={`${name+2}`}  onClick={handleCreateBUSDNFT} variant="primary" size="lg">
                            {buyCFALPHAButton}
                          </Button>
                        </div>
                        </Col>
                      </Row>
                  </Card.Text>
                  </Card.Footer>
                </Card>
              </Col>
          </Row>
          <div>&nbsp;</div>
      </div>  
        ))}
            <Row className="g-6">
            <Col>
            </Col>
            <Col className=" text-center "  style={{ background: "#000000", border: "2px solid #41464b", minWidth: '300px' }}>
            <h2 className="text-center">OG PRICE LIST</h2>
            <h5 className="text-center">OG #1 $5000</h5>
            <h5 className="text-center">OG #2 $4500</h5>
            <h5 className="text-center">OG #3 $4000</h5>
            <h5 className="text-center">OG #4 $3500</h5>
            <h5 className="text-center">OG #5 $3000</h5>
            <h5 className="text-center">OG #6 $2500</h5>
            <h5 className="text-center">OG #7 $2000</h5>
            <h5 className="text-center">OG #8 $1500</h5>
            <h5 className="text-center">OG #9 $1000</h5>
            <h5 className="text-center">OG #10-#19 $500</h5>
            <h5 className="text-center">OG #20-#29 $475</h5>
            <h5 className="text-center">OG #30-#39 $450</h5>
            <h5 className="text-center">OG #40-#49 $425</h5>
            <h5 className="text-center">OG #50-#59 $400</h5>
            <h5 className="text-center">OG #60-#69 $375</h5>
            <h5 className="text-center">OG #70-#79 $350</h5>
            <h5 className="text-center">OG #80-#89 $325</h5>
            <h5 className="text-center">OG #90-#99 $300</h5>
            </Col>
            <Col>
            </Col>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
              <div className="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/9MueIoJjF5Y?autoplay=1&rel=0&modestbranding=1" title="Cosmic Force intro video"  allowFullScreen></iframe>
              </div>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
              <div className="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/QorWCp85Ia0?autoplay=1&rel=0&modestbranding=1" title="Cosmic Force intro video"  allowFullScreen></iframe>
              </div>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
              <div className="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/e29CQo7WIHY?autoplay=1&rel=0&modestbranding=1" title="Cosmic Force intro video"  allowFullScreen></iframe>
              </div>
            </Row>
        </div>
      </main>
    </div>
  </div>
  </>
  )
     
  return (
    <>
      <div className="container-fluid mt-5">
      <div className="row">
        <main role="main" className="col-lg-12 mx-auto" style={{ maxWidth: '1000px' }}>
          <div className="content mx-auto">
          <Row className="g-6">
            <Col className=" text-center ">
            <img src='./images/Title_OG.png' className='img-fluid' alt='...' />
            </Col>
          </Row>
            <div>&nbsp;</div>
          <Row className="g-4">
            <h6 className="p-4 text-center">
            Contract: {NFTContractAddr}
          </h6>
          </Row>
          <Row className="g-4">
            <Col>
            </Col>
            <Col>
            <h4 className="text-center">
              Minted
            </h4>
            </Col>
            <Col>
            <h4 className="text-center">
              Max Supply
            </h4>
            </Col>
            <Col>
            </Col>
          </Row>
          <Row className="g-4">
            <Col>
            </Col>
            <Col>
            <h5 className="text-center">
            {totalNFTSupply}
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
              99
            </h5>
            </Col>
            <Col>
            </Col>
          </Row>
            <Row className="g-6">
            <Col className=" text-center ">
            <img src='./images/OG1_medium.png' className='img-fluid' alt='...' />
            </Col>
            </Row>
            <Row className="g-4">
            <Col>
            <h5 className="text-center">
            PRICE $300 - $5,000 IN $BUSD
            </h5>
            </Col>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
            <h6 className="p-4 text-center">
            Owning one of the 99 OG NFTs grants you full access to Leaderboards and Rewards from the Cosmic Force Treasury allowing you to progress in the game. The OG NFT also represents additional digital assets including: Starfighter, Custom Starfighter Skin with Personal Decal Graphics, Customizable Avatar, Combat Suit, Planetary Kit, Outpost Pod all issued as individual extra NFTs plus 35% discount of ALL in-game digital NFT asset purchases FOREVER once we launch on the Cosmic Blockchain.
            </h6>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-6">
            <Col className=" text-center ">
            <img src='./images/OG_Suit_UC.png' className='img-fluid' alt='...' />
            </Col>
            </Row>
            <Row className="g-6">
            <Col className=" text-center ">
            <img src='./images/OG_Text_v2.png' className='img-fluid' alt='...' />
            </Col>
            </Row >
            <Row className="g-6">
            <img src='./images/Spaceship.png' className='img-fluid' alt='...' />
            </Row>
            <div>&nbsp;</div>
            <Row className="g-6">
            <img src='./images/Outpost_Pod_no_Border_2.png' className='img-fluid' alt='...' />
            </Row>
            <div>&nbsp;</div>
            <div>&nbsp;</div>
            <Row className="g-6">
            <img src='./images/Planetary_Kit_No_border.png' className='img-fluid' alt='...' />
            </Row>
            <div>&nbsp;</div>
            {OGs.map(name => (
              <div>
               <Row className="g-6">
                <Col className=" text-center ">
                  <Card style={{ background: "#000000", border: "2px solid #41464b" }}>
                    <Card.Body  style={{ minWidth: '300px' }}>
                      <Card.Img variant="top" src={`./images/99_OGs_SM/OG(${name})sm.png`} />
                        
                      </Card.Body>
                    <Card.Footer style={{ background: "#212529", borderTop: "2px solid #41464b" }}>
                    <Card.Text>
                            <h4>#{name} {'OG'} - {items[name].soldtext}</h4>
                        <Row className="g-4">
                        <Col>
                          <div className="d-grid px-8">
                            <Button id={`${name}`} onClick={handleCreateBUSDNFT} variant="primary" size="lg">
                              {buyCFALPHAButton}
                            </Button>
                          </div>
                          </Col>
                        </Row>
                    </Card.Text>
                    </Card.Footer>
                  </Card>
                </Col>
                <Col className=" text-center ">
                  <Card style={{ background: "#000000", border: "2px solid #41464b" }}>
                    <Card.Body style={{ minWidth: '300px' }}>
                      <Card.Img variant="top" src={`./images/99_OGs_SM/OG(${name+1})sm.png`} />
                        
                      </Card.Body>
                    <Card.Footer style={{ background: "#212529", borderTop: "2px solid #41464b" }}>
                    <Card.Text>
                            <h4>#{name+1} {'OG'} - {items[name+1].soldtext}</h4>
                        <Row className="g-4">
                        <Col>
                          <div className="d-grid px-8">
                            <Button id={`${name+1}`}  onClick={handleCreateBUSDNFT} variant="primary" size="lg">
                              {buyCFALPHAButton}
                            </Button>
                          </div>
                          </Col>
                        </Row>
                    </Card.Text>
                    </Card.Footer>
                  </Card>
                </Col>
                <Col className=" text-center ">
                  <Card style={{ background: "#000000", border: "2px solid #41464b" }}>
                    <Card.Body style={{ minWidth: '300px' }}>
                      <Card.Img variant="top" src={`./images/99_OGs_SM/OG(${name+2})sm.png`} />
                        
                      </Card.Body>
                    <Card.Footer style={{ background: "#212529", borderTop: "2px solid #41464b" }}>
                    <Card.Text>
                            <h4>#{name+2} {'OG'} - {items[name+2].soldtext}</h4>
                        <Row className="g-4">
                        <Col>
                          <div className="d-grid px-8">
                            <Button id={`${name+2}`}  onClick={handleCreateBUSDNFT} variant="primary" size="lg">
                              {buyCFALPHAButton}
                            </Button>
                          </div>
                          </Col>
                          </Row>
                    </Card.Text>
                    </Card.Footer>
                  </Card>
                </Col>
            </Row>
            <div>&nbsp;</div>
        </div>  
          ))}
            <Row className="g-6">
            <Col>
            </Col>
            <Col className=" text-center "  style={{ background: "#000000", border: "2px solid #41464b", minWidth: '300px' }}>
            <h2 className="text-center">OG PRICE LIST</h2>
            <h5 className="text-center">OG #1 $5000</h5>
            <h5 className="text-center">OG #2 $4500</h5>
            <h5 className="text-center">OG #3 $4000</h5>
            <h5 className="text-center">OG #4 $3500</h5>
            <h5 className="text-center">OG #5 $3000</h5>
            <h5 className="text-center">OG #6 $2500</h5>
            <h5 className="text-center">OG #7 $2000</h5>
            <h5 className="text-center">OG #8 $1500</h5>
            <h5 className="text-center">OG #9 $1000</h5>
            <h5 className="text-center">OG #10-#19 $500</h5>
            <h5 className="text-center">OG #20-#29 $475</h5>
            <h5 className="text-center">OG #30-#39 $450</h5>
            <h5 className="text-center">OG #40-#49 $425</h5>
            <h5 className="text-center">OG #50-#59 $400</h5>
            <h5 className="text-center">OG #60-#69 $375</h5>
            <h5 className="text-center">OG #70-#79 $350</h5>
            <h5 className="text-center">OG #80-#89 $325</h5>
            <h5 className="text-center">OG #90-#99 $300</h5>
            </Col>
            <Col>
            </Col>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
              <div className="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/9MueIoJjF5Y?autoplay=1&rel=0&modestbranding=1" title="Cosmic Force intro video"  allowFullScreen></iframe>
              </div>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
              <div className="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/QorWCp85Ia0?autoplay=1&rel=0&modestbranding=1" title="Cosmic Force intro video"  allowFullScreen></iframe>
              </div>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
              <div className="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/e29CQo7WIHY?autoplay=1&rel=0&modestbranding=1" title="Cosmic Force intro video"  allowFullScreen></iframe>
              </div>
            </Row>
          </div>
        </main>
      </div>
    </div>
    </>
  );
}
